import { api } from '@/scripts/api';

export const LandingPageStatsService = {

    post(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/LandingPages/Stats';

            api.post(service, payload)
                .then(resolve)
                .catch(reject);

        });
    },
}